import React from 'react';
import { connect } from 'react-redux';
import { path } from 'ramda';
import PropTypes from 'prop-types';

import Header from './Header';
import Footer from '../../components/Footer';
import Loader from '../../components/Loader';
import FindUser from '../../components/FindUser';

const mapStore = (store) => ({
  loading: path(['layout', 'loading'], store),
});

const propTypes = {
  loading: PropTypes.bool,
};

const FindProfessional = ({ loading }) => (
  <div>
    <Header />
    <div className="my-5">
      <FindUser professional />
    </div>
    <Footer />
    <Loader loading={loading} />
  </div>
);

FindProfessional.propTypes = propTypes;

export default connect(mapStore)(FindProfessional);
